import CommonLandingContainer, {
  LandingHorizontalBlock,
} from 'src/components/landingComponents/containers/common';
import FirstBlock from './firstBlock';
import Oak from './test/oak';
import Biochemistry from './test/biochemistry';
import OtherTests from './test/other';

import ServiceInfo from '../home/serviceInfo';
import styles from './about.module.scss';
import { useSearchParams } from 'react-router-dom';
import { useLayoutEffect } from 'react';
import BreadcrumbSchema from 'src/components/breadcrumbs/schema';
import { Link } from '@mui/material';
import { Body, SubTitle } from 'src/components/landingComponents/typography';

const About = () => {
  const [searchParams] = useSearchParams();

  useLayoutEffect(() => {
    if (searchParams.get('show') === 'oak') {
      setTimeout(() => {
        // document.getElementById('oak').scrollIntoView({
        //   behavior: 'smooth',
        //   block: 'start',
        // });
        const element = document.getElementById('oak');
        const offset = (element?.offsetTop ?? 100) - 110;
        window.scrollTo({
          top: offset,
          behavior: 'smooth',
        });
      }, 100);
    }
  }, [searchParams]);

  return (
    <>
      <BreadcrumbSchema
        currentPage="about"
        description="Описание принципов работы системы Ламетри на основании наиболее популярных тестов: Общего анализа крови, липидограммы, глюкозы, гормонов и других основных биохимических маркеров"
      />
      <LandingHorizontalBlock id="greeting" className={styles.firstBlock}>
        <FirstBlock />
      </LandingHorizontalBlock>
      <LandingHorizontalBlock id="about" className={styles.firstBlock}>
        <CommonLandingContainer className={styles.intro}>
          <Body>
            Вы загружаете ПДФ со своими анализами и можете заполнить
            дополнительные поля, если это потребуется. Мы преобразуем ваши
            данные и проведем их через оцифрованные клинические рекомендации с
            официального сайта {'  '}
            <Link
              href="https://cr.minzdrav.gov.ru/clin-rec"
              rel="nofollow"
              target="_blank"
            >
              Минздрава
            </Link>
          </Body>
          <br />
          <Body>
            Чаще всего используются такие тесты как ОАК (Общий анализ крови),
            некоторые биохимические маркеры и гормоны, поэтому мы добавили
            объяснение как работает наша система на этих примерах.
          </Body>
        </CommonLandingContainer>
      </LandingHorizontalBlock>
      <LandingHorizontalBlock id="oak" className={styles.firstBlock}>
        <Oak />
      </LandingHorizontalBlock>
      <LandingHorizontalBlock id="biochemistry" className={styles.firstBlock}>
        <Biochemistry />
      </LandingHorizontalBlock>
      <LandingHorizontalBlock id="other" className={styles.firstBlock}>
        <OtherTests />
      </LandingHorizontalBlock>

      <LandingHorizontalBlock id="serviceInfo" className={styles.serviceInfo}>
        <ServiceInfo />
      </LandingHorizontalBlock>
    </>
  );
};

export default About;
